import gql from 'graphql-tag'

export const updateTag = gql`
mutation updateTag($id: ID!, $type: TagType!, $name: String!) {
	cashAssist {
		updateTag(id: $id, type: $type name: $name) {
			id
			uid
			type
			name
		}
	}
}`


export const createTag = gql`
mutation create($type: TagType!, $name: String!) {
	cashAssist {
		createTag(type: $type, name: $name) {
			id
			uid
			type
			name
		}
	}
}`

export const deleteTag = gql `
mutation deleteTag($id: ID!, $type: TagType!) {
	cashAssist {
		deleteTag(id: $id, type: $type) {
			id
			uid
			name
			type
		}
	}
}`
